import { render, staticRenderFns } from "./VisualizarTurmaDialog.vue?vue&type=template&id=2d478aeb"
import script from "./VisualizarTurmaDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarTurmaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports